import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from  '@angular/forms';
import { Router } from '@angular/router'

import { AddressesService } from "../services/addresses.service"
import { ShipmentsService } from "../services/shipments.service"
import { AuthService } from '../services/auth.service';
import { Observable } from 'rxjs/Observable';
import { Client } from '../models/client.model';
import { User } from '../../models/user.model';

@Component({
  selector: 'app-create-bol',
  templateUrl: './create-bol.component.html',
  styleUrls: ['./create-bol.component.css']
})
export class CreateBolComponent implements OnInit {
  //variables min
  isLoggedIn$: Observable<boolean>;   client:Client; user:User; services; service;  shipItem = {PCS:1, L:45, W:45, H:36, wt:250, dimwt:250, notes:"" };
  shipItems =[];  altAddresses;  bolForm: FormGroup;  clientId: number = 0;  clientName; pickupDateSet;  pickupDate;  pickupid;  pickupContact;   pickupContacts;  pickupLocation;  newPickupContact;  pickupContactid;  deliveryDate;  deliveryDateSet;  deliveryid;  deliveryLocation;  delivContact;  delivContacts;  newDelivContact;  delivContactid;  pickupSelected: boolean = false;  deliverySelected: boolean = false;  formValid = false;  formMessage = "";  newShipmentPost;  notes = "";    equipment;  equipmentSelected;  delivForm: FormGroup;    pickupForm: FormGroup;  pickupContactForm: FormGroup; delivContactForm: FormGroup;
  userShort;

  constructor(private addressesService: AddressesService,
               private shipmentsService: ShipmentsService,
                private router : Router,
                private authService: AuthService ) {
    this.authService.getUserClientPromise2()
    this.isLoggedIn$ = this.authService.isLoggedIn$
    this.authService.user$.subscribe((user:any) => {
      this.user = user;
      this.userShort = user.firstname + user.lastname.slice(0, 1);
      if (!user.message) {
        this.getAltAddresses(user.clientid);
      }
    });

    this.authService.client$.subscribe((client) => {
      this.client = client;
      if(client.cname != 'No Client Selected'){
      this.getAltAddresses(client.clientid);
      }
    });


    this.pickupDateSet = new Date().toISOString().slice(0, 19).replace('T', ' ');
   };

  ngOnInit() {
    this.bolForm =  new FormGroup({
      pickup: new FormControl(null, [Validators.required]),
      delivery: new FormControl(null, [Validators.required]),
      service: new FormControl(null, [Validators.required]),
      reference: new FormControl(null),
      equipment: new FormControl(null, [Validators.required])
    });
    this.setDeliveryDate()
    this.pickupDate = this.pickupDateSet;
    this.deliveryDate = this.deliveryDateSet
    this.loadServices();
    this.loadEquipment()

    // create Deliv form group
    this.delivForm = new FormGroup({
      delivfname: new FormControl('',[<any>Validators.required]),
      delivlname: new FormControl('',[<any>Validators.required]),
      delivphone: new FormControl('',[<any>Validators.required]),

    });

    // create Pickup form group
    this.pickupForm = new FormGroup({
      pickupfname: new FormControl('',[<any>Validators.required]),
      pickuplname: new FormControl('',[<any>Validators.required]),
      pickupphone: new FormControl('',[<any>Validators.required]),

    });

    // create Pickup Contact select form/ single Control
    this.pickupContactForm = new FormGroup({
      selectPickupcontact: new FormControl(([0,<any>Validators.required]))
    });

    // create Pickup Contact select form/ single Control
    this.delivContactForm = new FormGroup({
      selectdelivcontact: new FormControl(([0,<any>Validators.required]))
    });

  };

  onDelivSave(formValue) {
    const body = {fname: formValue.delivfname, lname: formValue.delivlname, phone: formValue.delivphone}
    this.addressesService.addAddressContact(body,this.deliveryLocation.id)
    .then(result => {
      this.delivContactid = result.insertId
      console.log(result.insertId)
      this.getAddressContacts(this.deliveryLocation.id)
      .then(contacts => {
        this.delivContacts = contacts;
        console.log(contacts)
        const delivContactArr = this.delivContacts.filter(contact => {return contact.contactid == this.delivContactid})
          this.delivContact = delivContactArr[0];
        this.onFormValid();
      })
    })
  };

  onPickupSave(formValue) {
    const body = {fname: formValue.pickupfname, lname: formValue.pickuplname, phone: formValue.pickupphone}
    this.addressesService.addAddressContact(body,this.pickupLocation.id)
    .then(result => {
      this.pickupContactid = result.insertId
      console.log(result.insertId)
      this.getAddressContacts(this.pickupLocation.id)
      .then(contacts => {
        this.pickupContacts = contacts;
        console.log(contacts)
        const pickupContactArr = this.pickupContacts.filter(contact => {return contact.contactid == this.pickupContactid})
          this.pickupContact = pickupContactArr[0];
        this.onFormValid();
      });
    });
  }

  onContactSelect(formvalue, type ) {
    console.log(`${formvalue} Type: ${type} `)
   this.setContactOnSelect(formvalue, type)
  }

  setContactOnSelect(contactid, type) {
    this.addressesService.getAddressContact(contactid)
    .then(contact => {
      if(type === 'pickup') {
        this.pickupContact = contact[0]
        this.pickupContactid = contactid;
      }else {
        this.delivContact = contact[0];
        this.delivContactid = contactid;

      }
    });
  }

  setDeliveryDate() {
    const todaysDate = new Date();
    // set case logic if friday add 3 if sat add 2 if sun add 1
    if(todaysDate.getDay() === 5){
      todaysDate.setDate(todaysDate.getDate() + 3);
    }else if (todaysDate.getDay() === 6){
      todaysDate.setDate(todaysDate.getDate() + 2);
    }else {
      todaysDate.setDate(todaysDate.getDate() + 1);
    };
       this.deliveryDateSet = todaysDate.toISOString().slice(0, 19).replace('T', ' ');;
  }

  loadServices(){
    this.services = [{name:'Economy'},{name:'Local'}, {name:'Next Day'}, {name:'2nd Day'}, {name:'3 Day'}, {name:'Hot Shot'},]

  }

  loadEquipment(){
    this.equipment = [{name:'None'}, {name:'Lift-Gate'},  {name:'Forklift'}, {name:'Other Put in Notes'},]
  }

  getAltAddresses(clientid){
    if(clientid != 0){
      this.addressesService.getAltAddresses(clientid)
      .then( addresses => {
        this.altAddresses = addresses;
        this.onPickupSelected(this.user.defaultpickupid)
      });
    }
  }

  onServiceSelected(service){
    this.service = service;
    this.onFormValid();
  }

  onEquipmentSelected(equipment){
    this.equipmentSelected = equipment;
    this.onFormValid();
  }

  onPickupSelected(id1){
    if (id1 > 0){
        // filter array to get pickup location data
      const index = this.altAddresses.findIndex(x => x.id == id1);
      this.pickupLocation =this.altAddresses[index];
      this.pickupSelected = true;
      this.pickupid = id1;
      this.getAddressContacts(id1)
      .then(contacts => {
        if(contacts.length > 0) {
          this.pickupContacts = contacts;
          this.pickupContact = this.pickupContacts[0];
          this.pickupContactid = this.pickupContacts[0].contactid;
          this.onFormValid();
        }
      });
    }
  }

  onDeliverySelected(id1){
   // filter array to get delivery location data
   const index = this.altAddresses.findIndex(x => x.id == id1)
    this.deliveryLocation =this.altAddresses[index];
    this.deliverySelected = true;
    this.deliveryid = id1;
    console.log(index)
    this.getAddressContacts(id1)
      .then(contacts => {
        if(contacts.length > 0) {
        this.delivContacts = contacts;
        this.delivContact = this.delivContacts[0];
        this.delivContactid = this.delivContacts[0].contactid;
        this.onFormValid();
        }
      });
  }

  getAddressContacts(id):Promise<any> {
    // get the contacts for this altAddress
    return this.addressesService.getAddressContacts(id)
    .then(contacts =>  contacts)

  }

  setShipItemDefaults() {
    this.shipItem = {PCS:1, L:45, W:45, H:36, wt:250, dimwt:250, notes:"" };

  };

  calcDimwt() {
    const dimwt = ((this.shipItem.L * this.shipItem.H * this.shipItem.W)/250)
    this.shipItem.dimwt = Math.ceil(dimwt);
  };

  onSaveShipItem() {
    const item = this.shipItem; // creates copy of item to stop editing
    this.shipItems.unshift(item);
    this.setShipItemDefaults();
    this.onFormValid();


  };

  onDeleteShipItem(index) {
    // remove item from shipItems array
    this.shipItems.splice(index);
    this.onFormValid();
  };

  onFormValid() {
    // check that feilds needed are filled in for req
    if (this.shipItems.length == 0 || this.deliverySelected === undefined){
        this.formValid = false;
        this.formMessage = "Must fill in form and add ONE shipment items Below"
    } else {
        this.formValid = true;
        this.formMessage = ""
    }
  };

  onsubmit(formvalue){
    console.log(formvalue)
    // if the form is valid then build the post object
    this.newShipmentPost = {
      clientid: this.client.clientid,
      pudate: this.pickupDate,
      deliverydate: this.deliveryDate,
      notes: this.notes,
      reference: formvalue.reference ||"",
      pickupid: formvalue.pickup || this.pickupLocation.id,
      deliveryid: formvalue.delivery,
      service: this.service,
      equipment: this.equipmentSelected,
      delivcontactid: this.delivContactid,
      pickupcontactid: this.pickupContactid
      } ;
      console.log(this.newShipmentPost)

  // Logic to send newshipment request to node/db goes here
      this.shipmentsService.createNewShipment(this.newShipmentPost)
      .then(newShipment => {
          // get shipreqid back from node after success
          const bolqtid = newShipment.insertId;
          const clientid = this.clientId;
          const that = this;
          // then save shipitems to node/db here for this id
            this.shipItems.forEach(function(item){
                item.bolqtid = bolqtid;
              // loops through shipItems array and enters them into tblshipitems
              that.shipmentsService.addShipItems(item)
              .then(result => result) // not used
              .catch(err => console.log(err))
          });
          this.shipmentsService.addToBoard(bolqtid, that.userShort, that.user.userid)
          .then((result) => {
            alert('ADDED BOL to Board');
            that.router.navigate(['/activeshipments']);
          }) // not used
          .catch(err => console.log(err))

      })
      .catch(err => console.log(err))
  }

  onNewAddress() {
    this.router.navigate(['/createaddress/' + this.client.clientid])
  };

    onInitNewContact() {
    this.newDelivContact = {
      fname:"", lname:"", phone:""
    };
    this.newPickupContact = {
      fname:"", lname:"", phone:""
    }
  };

  onNewDelivContact() {
    console.log(this.newDelivContact)
  }


}



// WEBPACK FOOTER //
// ./src/app/create-bol/create-bol.component.ts